import React, { useContext } from 'react';
import { Button } from 'react-bootstrap';
import classNames from 'classnames';
import { ChatContext } from 'context/Context';

const Submit = () => {
    const { message, chatsLoading } = useContext(ChatContext);

    return (
        <Button
            variant="falcon-primary"
            className={'p-3 me-0 ' + classNames({ 'text-primary': message.length > 0 && !chatsLoading, 'bg-200': chatsLoading })}
            type="submit"
            disabled={message.length == 0 || chatsLoading}
        >Send
        </Button>
    );
};

export default Submit;
